import React, {useState, useEffect, useContext, Fragment} from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import {BaseUrl} from 'contexts/baseUrl/baseUrl';
import 'react-times/css/classic/default.css';
import DatePicker from 'components/sales/datePicker/datePicker';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import FileUpload from "components/sales/fileUpload/fileUpload";
import useLatLng from 'hooks/uselatlng/uselatlng';
import CustomModal from "../../valetServices/modal";
import {toast} from 'react-toastify';

const SiteVisit = ({
                       documentUploadUrlPublic,
                       documentUrlDataPublic,
                       siteByCity,
                       siteDetails = [],
                       savedVisitTask = [],
                       createSiteVisit,
                       getSiteData,
                       siteDetailsList
                   }) => {

    const {baseUrl} = useContext(BaseUrl);
    let markers = [];
    const [inputList, setInputList] = useState([{
        site_id: '',
        date: '',
        lat: '',
        long: '',
        image_url: '',
        desc: "",
        task_type: '',
        requested_by: '',
        site_name:'',
        poc_name:''
    }])

    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const [isLoading, setIsLoading] = useState(false);
    const [desc, setDesc] = useState("")
    const [date, setDate] = useState("")
    const islatlng = useLatLng();
    const [isAllow, setIsAllow] = useState(false);
    const [count, setCount] = useState(0)
    const [totalDistance, setDistance] = useState("")
    const [siteLocation, setSiteLocaation] = useState({
        'lat': 0,
        'long': 0
    })
    const [showInput, setShowInput] = useState(false);

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    const handleInputList = (val, index) => {
        let list = [...inputList]
        list[0][index] = val
        setInputList([...list])
    }

    const toRad = (Value) => {
        return Value * Math.PI / 180
    }

    const calcCrow = (lat1, lon1, lat2, lon2) => {
        var R = 6371 // km
        var dLat = toRad(lat2 - lat1)
        var dLon = toRad(lon2 - lon1)
        var lat1 = toRad(lat1)
        var lat2 = toRad(lat2)

        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        var d = R * c
        return d
    }

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await siteByCity({'city_id': 0})
            setIsLoading(false);
        })();
    }, []);

    const handleSiteData = async (siteId) => {
        if (siteId === "") {
            return false
        }
        setIsLoading(true)
        getSiteData(siteId)
        setIsLoading(false)
    }

    const handleTaskType = (id) => {
        if (id === 'Call support') {
            setShowInput(true);
        } else {
            setShowInput(false);
        }
    }

    useEffect(() => {
        setDate(siteDetails?.response?.data?.todayDate)
    }, [siteDetails])

    useEffect(() => {
        if (siteDetailsList !== undefined && siteDetailsList !== null && Object.keys(siteDetailsList).length > 0) {
            let distance = calcCrow(islatlng?.lat, islatlng?.lng, siteDetailsList?.lead?.latitude, siteDetailsList?.lead?.longitude)
            setDistance(distance)
            setSiteLocaation({'lat': siteDetailsList?.lead?.latitude, 'long': siteDetailsList?.lead?.longitude})
        }
    }, [islatlng?.lat, siteDetailsList])

    const handleSubmit = async () => {
        if (isAllow) {
            alert(localization.locationPermission);
        }
        let list = [...inputList]
        if (list[0]['site_id'] === '' || list[0]['task_type'] === '') {
            toast.error('Please fill all required fields.');
            return false;
        }
        list[0]['lat'] = islatlng?.lat
        list[0]['long'] = islatlng?.lng
        list[0]['desc'] = desc
        list[0]['date'] = date

        setIsLoading(true)
        let res = await createSiteVisit(list[0])
        setCount(count + 1)
        setIsLoading(false)
    }

    function renderMarkers(map, maps) {
        markers = [
            {
                title: "Site Visit",
                position: {lat: Number(islatlng?.lat), lng: Number(islatlng?.lng)}
            }
        ];

        if (siteLocation.lat !== undefined) {
            markers.push({
                title: "Site",
                position: {
                    lat: Number(siteLocation.lat),
                    lng: Number(siteLocation.long)
                }
            })
            {
                markers.map((marker1, index) => (
                    new maps.Marker({
                        key: index,
                        position: marker1.position,
                        name: marker1.name,
                        map,
                        title: (marker1.title === 'Site Visit') ? 'You are here!' : 'Site',
                        icon: {url: (marker1.title === 'Site Visit') ? "http://maps.google.com/mapfiles/ms/icons/blue-dot.png" : "http://maps.google.com/mapfiles/ms/icons/red-dot.png"}

                    })
                ))
            }
            ;
        }
    }

    return (
        <Layout
            title={localization.addtask}
            isGoback
            isLoading={isLoading}
            linkFlag
            linkUrl={`${baseUrl}/site-visit-list`}
        >
            <div className="container-fluid">
                {savedVisitTask !== [] && savedVisitTask?.status_code !== 200 && savedVisitTask?.status !== 0 &&
                    <CustomModal msg={savedVisitTask?.response?.message || savedVisitTask?.message} click={count}/>}
                {savedVisitTask !== [] && (savedVisitTask?.status_code === 200 || savedVisitTask?.status === 0 || savedVisitTask?.response?.status === 200 || savedVisitTask?.response?.status === true) &&
                    <CustomModal msg={savedVisitTask?.response?.message || savedVisitTask?.message} isPageLoad={true} click={count}/>}
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-sm-4">
                                <DropDownInput
                                    data={siteDetails?.response?.data?.sites}
                                    label={localization.site}
                                    required={true}
                                    isStarRequired={true}
                                    errorMsg={localization.isRequired}
                                    getIdValue={(val) => {
                                        handleSiteData(val.id)
                                        handleInputList(val.id, 'site_id')
                                    }}
                                    value={''}
                                />
                            </div>
                            {parseInt(inputList[0]?.site_id) === 0 &&
                                <div className="col-sm-4">
                                    <ConstantInput
                                        label={localization.siteName}
                                        value={''}
                                        required={true}
                                        isStarRequired={true}
                                        errorMsg={localization.isRequired}
                                        //disabled={disabled}
                                        handleChange={(val) => {
                                            handleInputList(val, 'site_name')
                                        }}
                                    />
                                </div>
                            }
                            <div className="col-sm-4">
                                <DatePicker
                                    handleChange={(val) => {
                                        setDate(val)
                                    }}
                                    label={`Date`}
                                    required={false}
                                    value={siteDetails?.response?.data?.todayDate}
                                    disabled={true}
                                />
                            </div>
                            {/*</div>*/}
                            <div className="col-sm-4">
                                <ConstantInput
                                    label={localization.lat}
                                    value={islatlng?.lat}
                                    required={true}
                                    isStarRequired={true}
                                    errorMsg={localization.isRequired}
                                    //disabled={disabled}
                                    handleChange={(val) => {
                                        handleInputList(val, 'lat')
                                    }}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-sm-4">
                                <ConstantInput
                                    label={localization.lng}
                                    value={islatlng?.lng}
                                    required={true}
                                    isStarRequired={true}
                                    errorMsg={localization.isRequired}
                                    //disabled={disabled}
                                    handleChange={(val) => {
                                        handleInputList(val, 'long')
                                    }}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-sm-4">
                                <DropDownInput
                                    data={[
                                        {id: 'New Site Config', name: 'New Site Config'},
                                        {id: 'Existing Site Config', name: 'Existing Site Config'},
                                        {id: 'New Site Testing', name: 'New Site Testing'},
                                        {id: 'Troubleshooting', name: 'Troubleshooting'},
                                        {id: 'Call support', name: 'Call support'},
                                        {id: 'Others', name: 'Others'},
                                    ]}
                                    label={`Task Type`}
                                    required={true}
                                    isStarRequired={true}
                                    errorMsg={localization.isRequired}
                                    getIdValue={(val) => {
                                        handleTaskType(val.id);
                                        handleInputList(val.id, 'task_type')
                                    }}
                                    value={''}
                                />
                            </div>
                            {showInput ? (
                                <div className="col-sm-4">
                                    <ConstantInput
                                        label={`Requested By`}
                                        value={``}
                                        required={true}
                                        //isStarRequired={true}
                                        handleChange={(val) => {
                                            handleInputList(val, 'requested_by')
                                        }}
                                    />
                                </div>
                            ) : null}
                            <div className="col-sm-4">
                                <FileUpload
                                    id={"fileAttach"}
                                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                                    documentUploadUrl={documentUploadUrlPublic}
                                    documentUrlData={documentUrlDataPublic}
                                    onChange={(val) =>
                                        handleInputList(val, 'image_url')
                                    }
                                    multiple={true}
                                >
                    <span className="btn btn-transparent">
                        {localization.media}
                    </span>
                                </FileUpload>
                            </div>
                            <div className="col-sm-4">
                                <ConstantInput
                                    label={`Poc Name`}
                                    value={``}
                                    required={true}
                                    //isStarRequired={true}
                                    handleChange={(val) => {
                                        handleInputList(val, 'poc_name')
                                    }}
                                />
                            </div>
                            {siteDetailsList && siteDetailsList !== undefined && siteDetailsList !== null && Object.keys(siteDetailsList).length > 0 &&
                                <div className="col-md-12 ml-1">
                                    {totalDistance !== 'NaN' &&
                                        <h5 style={{"color": "#6c7ae0"}}>you are {Number(totalDistance).toFixed(2)} KM
                                            away from
                                            site</h5>}
                                    <div className='row pointer-where-are-you'>
                                        <div className="col-m-6">
                                            <img
                                                src="http://maps.google.com/mapfiles/ms/icons/blue-dot.png"/> : <strong>You{"\u00a0\u00a0"} </strong>
                                            (Lat: {islatlng?.lat} {"\u00a0\u00a0"} Long: {islatlng?.lng})
                                        </div>
                                        <div className="col-m-6">
                                            <img
                                                src="http://maps.google.com/mapfiles/ms/icons/red-dot.png"/> : <strong>Site {"\u00a0\u00a0"}</strong>
                                            {siteDetailsList !== undefined && siteDetailsList !== null && Object.keys(siteDetailsList).length > 0 &&
                                                <>
                                                    (Lat: {siteDetailsList['lead']['latitude']} {"\u00a0\u00a0"} Long: {siteDetailsList['lead']['longitude']})
                                                </>
                                            }
                                        </div>
                                    </div>
                                    <div className="map">
                                        <div className="google-map">
                                            {/* {(mapLocation && mapLocation.lat && siteDetailsList?.lead?.latitude &&
                                                <GoogleMapReact
                                                    bootstrapURLKeys={{key: 'AIzaSyCweWEGenU5sDidT_1MKho5VoAhMC4CgtQ'}}
                                                    defaultCenter={mapLocation}
                                                    defaultZoom={15}
                                                    yesIWantToUseGoogleMapApiInternals
                                                    onGoogleApiLoaded={({map, maps}) => renderMarkers(map, maps)}
                                                >
                                                </GoogleMapReact>
                                            )} */}
                                        </div>
                                    </div>
                                </div>
                            }

                            <div className='col-md-12 col-sm-4 mt-3'>
                                <TextAreaInput
                                    type="text"
                                    rows={6}
                                    className={`inline-css scrollbar-styling`}
                                    label={localization.description}
                                    value={desc}
                                    inputValue={desc}
                                    required={true}
                                    isStarRequired={true}
                                    errorMsg={localization.isRequired}
                                    handleChange={(e) => {
                                        setDesc(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-12 col-sm-5">
                            <button className="btn btn-sm btn-primary" onClick={handleSubmit}>Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );

};
export default SiteVisit;